import { render, staticRenderFns } from "./IconArrowNarrowUpOutline.vue?vue&type=template&id=a51ed7a4"
import script from "./IconArrowNarrowUpOutline.vue?vue&type=script&lang=js"
export * from "./IconArrowNarrowUpOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports